export function saveDeclarationsRequest(declarationsRequest) {
  const saveDeclarationsRequestOptions = {
    method: "POST",
    body: JSON.stringify(declarationsRequest),
  };

  const declarationsUrl = `${
    import.meta.env.VITE_APPLICATION_API_URI
  }/loan/declarations`;
  return fetch(declarationsUrl, saveDeclarationsRequestOptions);
}

export function saveCodebtorDeclarationRequest() {
  const saveCodebtorDeclarationRequestOption = {
    method: "POST",
  };

  const declarationConsentUrl = `${
    import.meta.env.VITE_APPLICATION_API_URI
  }/loan/declaration-consent`;
  return fetch(declarationConsentUrl, saveCodebtorDeclarationRequestOption);
}
